import { render, staticRenderFns } from "./PaymentSettlementsByHole.vue?vue&type=template&id=20c5392b&scoped=true&"
import script from "./PaymentSettlementsByHole.vue?vue&type=script&lang=js&"
export * from "./PaymentSettlementsByHole.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSettlementsByHole.vue?vue&type=style&index=0&id=20c5392b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c5392b",
  null
  
)

export default component.exports